import React, { useState, useEffect } from 'react';
import { FlatList, ScrollView, SectionList, TouchableOpacity, View } from 'react-native'

import api from "../../../../../utils/api"
import tw from '../../../../../styles/tailwind';
import Text from '../../../../../components/Text';
import Icon from '../../../../../components/IcomoonIcon';
import { Image } from 'expo-image';
import { useQuery } from '@tanstack/react-query';
import AddPaymentModal from '../Fees/AddPaymentModal';
import { currency } from '../Reports/ReportsSection';
import TabsSelector from '../../../../../components/TabsSelector';
import MoraReportSection from './MoraReportSection';


function DebtorRow({ debtor, onPress }) {
  return (
    <TouchableOpacity
      style={tw`py-2 border-b border-gray-200 px-4`}
      onPress={onPress}
    >
      <View style={tw`row justify-between`}>
        <Text>{debtor.unit?.name}</Text>
        <Text><Text style={tw`text-gray-500`}>Cuotas pendientes:</Text> {debtor.fees_count}</Text>
      </View>
      <View style={tw`row justify-between`}>
        {
          <Text style={tw`text-gray-400`}>{debtor.unit?.owners?.[0]?.user?.name}</Text>
        }

        <Text><Text style={tw`text-gray-500`}>Total:</Text> <Text style={tw`text-red font-500`}>{currency(debtor.fees_total)}</Text></Text>
      </View>
    </TouchableOpacity>
  )
}


export default function DebtorsSection({ communityId }) {
  const [selectedUnitId, setSelectedUnitId] = useState();
  const [subTab, setSubTab] = useState('list');

  const { isInitialLoading, error, data: debtors, refetch } = useQuery({
    queryKey: ['community.fees.debtors', communityId],
    queryFn: () => api.get(`/communities/${communityId}/fees/debtors`).then(response => response.data),
  })


  const { data: feesOverview, refetch: refetchFeesOverview } = useQuery({
    queryKey: ['community.fees.overview', communityId],
    queryFn: () => api.get(`/communities/${communityId}/fees/overview`).then(response => response.data),
  })



  return (
    <View style={tw`flex-1 bg-[#F3F2F3]`}>
      <View style={tw`px-4 pt-4 pb-2`}>
        <TabsSelector
          segmented
          options={[
            { label: "Deudores", value: "list" },
            { label: "Reporte", value: "report" },
          ]}
          onChange={setSubTab}
        />
      </View>

      {
        subTab === 'report' ?
          <MoraReportSection communityId={communityId} />
        :
      <View style={tw`flex-1`}>
      {
        isInitialLoading &&
        <Text style={tw`my-8 text-lg text-center text-gray-400`}>Cargando...</Text>
      }

      {
        feesOverview?.totals &&
        <View style={tw`row justify-between px-5 py-3 border-b border-gray-300`}>
          <View style={tw`items-center`}>
            <Text style={tw`text-gray-500`}>Total por cobrar</Text>
            <Text style={tw`font-500 text-base`}>{currency(feesOverview?.totals?.pending_amount)}</Text>
          </View>

          <View style={tw`items-center`}>
            <Text style={tw`text-gray-500`}>Viviendas pendientes</Text>
            <Text style={tw`font-500 text-base`}>{debtors ? debtors.length : '-'}</Text>
          </View>
        </View>
      }

      {
        debtors?.length == 0 &&
        <Text style={tw`mt-25 text-lg text-center text-gray-400`}>Sin deudores</Text>
      }

      <FlatList
        data={debtors}
        contentContainerStyle={tw`pt-2`}
        renderItem={({ item }) => <DebtorRow debtor={item} onPress={() => setSelectedUnitId(item.unit.uuid)} />}
        keyExtractor={(item, index) => item.unit?.uuid ?? String(index)}
      />
      </View>
      }

      {
        selectedUnitId &&
          <AddPaymentModal
            unitId={selectedUnitId}
            communityId={communityId}
            onRequestClose={() => setSelectedUnitId()}
            visible={true}
            onPaymentCreated={() => {
              setSelectedUnitId(false)
              refetch()
            }}
          />
      }
    </View>
  )
}